import { PAYEX_URL } from 'constants/config';
import { decamelizeKeys } from 'humps';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';
export type ExperimentFlagResponse = {
  name: string;
  enabled: boolean;
  variables: Record<string, string | boolean | number>;
};

const experiments = {
  checkFlag: async (
    flagName: string,
    userContext?: Record<string, string | boolean | number>,
    userId?: string,
  ): Promise<ExperimentFlagResponse> => {
    const path = `${PAYEX_URL}/experiments/flags`;
    const body = JSON.stringify({
      name: flagName,
      ...(userContext ? decamelizeKeys(userContext) : {}),
      ...(userId ? { user_id: userId } : {}),
    });
    const options = { method: 'POST', body };

    return fetchWithAuthentication(path, options);
  },

  trackEvent: (
    eventName: string,
    eventProperties?: Record<string, string | boolean | number>,
    userId?: string,
    userEmail?: string,
  ) => {
    const path = `${PAYEX_URL}/experiments/track_event`;
    const body = JSON.stringify({
      name: eventName,
      ...(eventProperties
        ? { event_properties: decamelizeKeys(eventProperties) }
        : {}),
      ...(userId ? { user_id: userId } : {}),
      ...(userEmail ? { user_email: userEmail } : {}),
    });

    const options = { method: 'POST', body };

    return fetchWithAuthentication(path, options);
  },
};

export { experiments };
